import { Validator } from './validator';

export const validatorStore = new WeakMap<HTMLFormElement, Validator>();
